import React, { ReactNode, useMemo } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { IndentContainer, RounderContainer } from '@r1-frontend/ui-react/experimental/containers';
import CardImageWithCarousel from '@r1-frontend/ui-react/organisms/Card/CardImage/CardImageWithCarousel';
import * as S from '@r1-frontend/ui-react/organisms/Card/CardImage/styled';
import { useMatchMediaByWidth } from '@r1-frontend/shared/hooks/useMatchMedia';

type TProps = {
    images: string[],
    labels?: ReactNode[],
}

const CardImage = (props: TProps): JSX.Element => {
    const isMobile = useMatchMediaByWidth(wideBreakpoints.mobile);
    const { hasListOfImage, labels } = useMemo(() => (
        {
            hasListOfImage: props.images.length > 1,
            labels: props.labels && isMobile ? props.labels.slice(0, 1) : props.labels,
        }
    ), [isMobile, props.images.length, props.labels]);

    return (
        <>
            <IndentContainer $united={[8]}>
                <RounderContainer $desktop={24} $mobile={16}>
                    {hasListOfImage
                        ? <CardImageWithCarousel images={props.images} labels={props.labels}/>
                        : <S.ImageWrapper>
                            {labels ? <S.LabelWrapper>{labels}</S.LabelWrapper> : null}
                            <LazyLoadImage
                                src={props.images[0]}
                                alt={'equipment'}
                                visibleByDefault={true}
                            />
                        </S.ImageWrapper>}
                </RounderContainer>
            </IndentContainer>
        </>
    );
};

export default CardImage;
